export default "<div class=\"halo-loader\" [class.halo-loader--spinning]=\"isLoading\"><span class=\"halo-loader__spinner\"></span></div>\n";